import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ResponsivContent from "../../components/ResponsivContent";
import styles from "./styles.module.css";
import SendIcon from "@mui/icons-material/Send";
import {
  Autocomplete,
  Button,
  CircularProgress,
  TextField,
} from "@mui/material";
import styled from "styled-components";
import { CadastroContext } from "../../config/Context/CadastroContext";
import { buscarComboPorCodigo } from "../../services/auth.service";
import SnackBar from "../../components/SnackBar";
import { cadastroSimplesCliente } from "../../services/api-upload.service";
import { LoginContext } from "../../config/Context/LoginContext";
import ModalArquivos from "./ModalArquivos";

const SelecionarTiposNegocioSimples = () => {
  const [tiposNegocio, setTiposNegocio] = useState([]);
  const [options, setOptions] = useState([]);
  const navigate = useNavigate();
  const { dados, setDados } = useContext(CadastroContext);
  const { dadosLogin } = useContext(LoginContext);
  const [openModalArquivos, setOpenModalArquivos] = useState(false);
  const [loading, setLoading] = useState(false);
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const tipos = await buscarComboPorCodigo("TIPOSNEGOCIO");

        const listaItens = tipos.detalhes.itensCombo.map((item) => {
          const splitValues = item.split("/|/");
          return {
            id: splitValues[0],
            descricao: splitValues[1],
          };
        });

        setOptions(listaItens);
      } catch (error) {
        handleSnackBar({
          type: "error",
          msg: "Erro ao cadastrar cliente. Contate o suporte.",
        });
      }
    };

    fetchData();
  }, []);

  const handleSnackBar = (obj) => {
    setObjSnackBar(obj);
  };

  //#region

  // Fluxo do modal de anexos (certificado/procuração/documentos)
  const handleModalClient = (action) => {
    setOpenModalArquivos(action);
  };

  // Novo: callback para sucesso do modal
  const handleModalSuccess = (msg) => {
    setOpenModalArquivos(false);
    handleSnackBar({ type: "success", msg });
    setTimeout(() => {
      navigate(`/dashboard`);
    }, 2000);
  };

  const nextStepModal = () => {
    if (tiposNegocio.length > 0) {
      setDados({
        ...dados,
        tiposNegocio: tiposNegocio.map((item) => item.descricao),
      });
      handleModalClient(true);
    } else {
      handleSnackBar({
        type: "error",
        msg: "Por favor, selecione ao menos 1 tipo de negócio.",
      });
    }
  };

  const handleSubmit = async () => {
    try {
      if (tiposNegocio.length === 0) {
        handleSnackBar({
          type: "error",
          msg: "Por favor, selecione ao menos 1 tipo de negócio.",
        });
        return;
      }

      setLoading(true);

      const body = {
        ...dados,
        cpf: dados.cpf ? dados.cpf.replace(/\D/g, "") : "",
        cnpj: dados.cnpj ? dados.cnpj.replace(/\D/g, "") : "",
        tipoCadastro: dadosLogin.tipoCadastroPlanTribKey,
        tiposNegocio: tiposNegocio.map((item) => item.descricao),
      };

      // DEFINIR MOMENTO PARA NOTIFICAÇÃO
      // await enviarNotificacao({
      //   titulo: `Novo ${
      //     dadosLogin.tipoCadastroPlanTribKey === "P" ? "Parceiro" : "Associado"
      //   } Cadastrado!`,
      //   texto: `Um novo ${
      //     dadosLogin.tipoCadastroPlanTribKey === "P" ? "parceiro" : "associado"
      //   } foi cadastrado e você já pode realizar a análise do mesmo.`,
      //   grupos: ["JURIDICO"],
      //   path: `/gestao/juridico?tipo=${
      //     dadosLogin.tipoCadastroPlanTribKey === "P"
      //       ? "Parceiro&id"
      //       : "Associado&id"
      //   }=${dadosLogin.idUsuario}`,
      //   tipo: "WARNING",
      // });

      // if (dados.idPai) {
      //   await enviarNotificacao({
      //     titulo: `Novo Parceiro Cadastrado!`,
      //     texto: `Um novo parceiro foi cadastrado e você já pode ve-lo na tela de Vínculos.`,
      //     usuarios: [dados.idPai],
      //     path: `/gestao/vinculos`,
      //     tipo: "SUCESS",
      //   });
      // }

      const formDataToSend = new FormData();
      formDataToSend.append("cliente", JSON.stringify({ ...body }));
      await cadastroSimplesCliente(formDataToSend);
      handleSnackBar({
        type: "success",
        msg: "Cliente cadastrado com sucesso.",
      });

      setTimeout(() => {
        navigate(`/dashboard`);
      }, 2000);
    } catch (error) {
      console.error("Erro ao enviar dados:", error);
      handleSnackBar({
        type: "error",
        msg: "Erro ao cadastrar cliente. Contate o suporte.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleChangeAutoComplete = (value) => {
    setTiposNegocio(value);
  };

  return (
    <div className={styles.main}>
      <ResponsivContent>
        <div className={styles.content}>
          <div className={styles.content__tipos}>
            <h2 className={styles.title}>
              Selecione os tipos de negócio que deseja:
            </h2>
            <div className={styles.separador}>
              <Autocomplete
                multiple
                disableCloseOnSelect
                isOptionEqualToValue={(option, value) => option.id === value.id}
                options={options}
                getOptionLabel={(option) => option.descricao}
                value={tiposNegocio}
                onChange={(_, e) => handleChangeAutoComplete(e)}
                renderInput={(params) => (
                  <TextField {...params} label="Tipos de negócio" />
                )}
                fullWidth
              />
            </div>
          </div>
        </div>
        <Button
          type="button"
          className={styles.botaoProsseguir}
          variant="contained"
          onClick={nextStepModal}
          startIcon={<SendIcon sx={{ marginRight: "0.2rem" }} />}
          sx={{
            "&:hover": {
              transform: "scale(0.95)",
            },
          }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            <>Salvar</>
          )}
        </Button>
      </ResponsivContent>
      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={handleSnackBar} />

      <ModalArquivos
        open={openModalArquivos}
        onClose={() => handleModalClient(false)}
        tiposNegocio={tiposNegocio}
        onSuccess={handleModalSuccess}
      />
    </div>
  );
};

export default SelecionarTiposNegocioSimples;
